import { useState } from 'react';
import axios from 'axios';
import { Send, CheckCircle2, Feather } from 'lucide-react';
import { HOME } from '@/constants/testIds';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await axios.post(`${API}/subscribers`, { email, source: 'footer' });
      setStatus('success');
      setMessage('Welcome to Field Notes. We\u2019ll be in touch soon.');
      setEmail('');
    } catch (err) {
      setStatus('error');
      const detail = err?.response?.data?.detail;
      setMessage(
        typeof detail === 'string'
          ? detail
          : 'Could not sign up just now. Please try again in a moment.',
      );
    }
  };

  return (
    <section
      data-testid={HOME.newsletterSection}
      className="bg-[var(--brand-forest-deep)] text-[var(--brand-parchment)] relative overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-40" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-20 lg:py-24 text-center">
        <Feather size={28} className="text-[var(--brand-gold)] mx-auto" strokeWidth={1.4} />
        <h3 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
          Field Notes from the Estate.
        </h3>
        <p className="mt-4 text-[var(--brand-parchment)]/80 text-base lg:text-lg max-w-xl mx-auto leading-relaxed">
          A rare, honest letter when we&rsquo;ve something worth saying. Weather warnings, kit
          lessons, and the odd story from a working hill day. No marketing nonsense — you
          have our word on that.
        </p>

        <form
          onSubmit={submit}
          className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <input
            data-testid={HOME.newsletterEmail}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@yourplace.co.uk"
            className="flex-1 bg-transparent border border-[var(--brand-parchment)]/40 px-4 py-3 text-sm placeholder-[var(--brand-parchment)]/50 focus:outline-none focus:border-[var(--brand-gold)] transition-colors"
          />
          <button
            data-testid={HOME.newsletterSubmit}
            disabled={status === 'sending'}
            className="btn-gold px-6 py-3 text-sm font-semibold inline-flex items-center justify-center gap-2 rounded-none disabled:opacity-60"
          >
            {status === 'sending' ? 'Joining\u2026' : 'Join'}
            <Send size={14} />
          </button>
        </form>

        {status === 'success' && (
          <p
            data-testid={HOME.newsletterSuccess}
            className="mt-5 inline-flex items-center gap-2 text-sm text-[var(--brand-gold)]"
          >
            <CheckCircle2 size={16} /> {message}
          </p>
        )}
        {status === 'error' && (
          <p data-testid={HOME.newsletterError} className="mt-5 text-sm text-red-300">
            {message}
          </p>
        )}
      </div>
    </section>
  );
}
